import React from 'react'
import { Pane } from 'evergreen-ui'
import SideNav, { NavItem, NavIcon, NavText } from '@trendmicro/react-sidenav';
import '@trendmicro/react-sidenav/dist/react-sidenav.css';
import { withRouter } from 'react-router-dom'
import { Icon } from 'evergreen-ui'
import { getUserRoutes as routes } from '../Routes/Routes';
import { handleLogout } from '../Redux/reducers/auth';
import { connect } from 'react-redux'
const SideMenu = ({ visible = true, changeVisibility, userInfo, ...props }) => {
  return (
    <SideNav style={{ zIndex: 1 }}

      defaultExpanded={true}
      className='navbar-color'

      onSelect={(selected) => {
        const { history, location, dispatch } = props

        if (selected === 'logout') {
          return dispatch(handleLogout())
        }

        if (location.pathname !== selected)
          history.push(selected)
      }}
    >
      <Pane
        className='img-div'
      >
        <img className='img-logo' src='../assets/images/logo.png' alt='img'/>
      </Pane>
      <SideNav.Nav defaultSelected={props.location.pathname === '/' ? '/home' : props.location.pathname}>
        {routes(userInfo.role).filter(route => !route.invisible).map(item => (
          <NavItem key={item.path}
            eventKey={item.path} className='nav-item'>
            <NavIcon className='nav-item'>
              <Icon icon={item.icon} size={14} />
            </NavIcon>
            <NavText className='nav-item'>
              {item.label}
            </NavText>
          </NavItem>
        ))}
        <NavItem key='logout'
          eventKey='logout' className='nav-item'>
          <NavIcon className='nav-item'>
            <Icon icon='log-out' size={14} />
          </NavIcon>
          <NavText className='nav-item'>
            Sair
        </NavText>
        </NavItem>
      </SideNav.Nav>

    </SideNav >
  )
}
const mapStateToProps = (state) => ({
  userInfo: state.auth.account
})
export default connect(mapStateToProps)(withRouter(SideMenu))  